import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function TestimonialsMarquee() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/testimonials").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  const doubled = [...items, ...items];

  return (
    <section className="py-16 md:py-20 overflow-hidden bg-[#FAFAF8]" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 mb-10">
        <div className="kicker mb-3">Guest voices</div>
        <h2 className="font-sora text-3xl md:text-4xl font-semibold tracking-tight text-[#0E2E24] max-w-3xl leading-tight">
          The people who've already celebrated.
        </h2>
      </div>

      <div className="marquee-wrap relative">
        <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[#FAFAF8] to-transparent z-10" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[#FAFAF8] to-transparent z-10" />
        <div className="marquee-track flex gap-8 w-max">
          {doubled.map((t, i) => (
            <figure
              key={`${t.id}-${i}`}
              className="w-[360px] md:w-[440px] shrink-0 bg-white rounded-3xl p-8 border border-[#0E2E24]/10"
              data-testid={`testimonial-${t.id}-${i}`}
            >
              <div className="kicker text-[#F4A930] mb-4">{t.occasion}</div>
              <blockquote className="font-display text-xl leading-snug text-[#0E2E24]">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3">
                <img src={t.avatar} alt={t.name} className="h-10 w-10 rounded-full object-cover" />
                <div>
                  <div className="font-sora text-sm font-medium text-[#0E2E24]">{t.name}</div>
                  <div className="text-xs text-[#111111]/60">{t.role}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
